import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { FormattedMessage } from 'react-intl/dist';
import styled from 'styled-components';

import { formatDateToMMDDYYYY } from '../../../utils/dates/dateMethods';
import DatePickerInputMask from './DatePickerInputMask';

const DatePickerStyled = styled.div`
    .date-picker-icon {
        float: right;
        margin-right: 2px;
        margin-top: -38px;
        position: relative;
        height: 36px;
        width: 40px;
        padding: 10px;
        background-color: #EEEEF4};
    }
`;

const DatePickerContainer = styled.div`
    .react-datepicker-wrapper {
        margin-bottom: 0px !important;
    }
`;

export interface IDatePickerProps {
    id: string;
    name: string;
    onDateChange: (date: Date | null) => void;
    minDate?: Date | undefined;
    maxDate?: Date | undefined;
    placeholder?: string;
    dateFormat?: string;
    value?: Date | undefined;
    showYearDropdown?: boolean;
    showIcon?: boolean;
    noOfYearsToShow?: number;
    [x: string]: any;
    hasError?: boolean;
    withMask?: boolean;
    isRequired: boolean;
    labelText: string;
    disabled?: boolean;
}

const ReactDatepicker = forwardRef<HTMLDivElement, IDatePickerProps>(
    (
        {
            id,
            name,
            onDateChange,
            minDate = undefined,
            maxDate = undefined,
            placeholder = 'MM/DD/YYYY',
            dateFormat = 'MM/dd/yyyy',
            value,
            showYearDropdown = true,
            showIcon = true,
            noOfYearsToShow = 100,
            hasError = false,
            withMask = false,
            isRequired,
            labelText,
            disabled,
            ...rest
        },
        ref,
    ) => {
        const commonProps = {
            autoComplete: 'off',
            dateFormat,
            icon: showIcon ? <></> : <FontAwesomeIcon icon="calendar-alt" />,
            id: id,
            name: name,
            placeholderText: placeholder,
            scrollableYearDropdown: true,
            showIcon,
            showYearDropdown,
            yearDropdownItemNumber: noOfYearsToShow,
            selected: value || rest.selected || undefined,
            portalId:'root-portal',
        };

        return (
            <>
                <DatePickerContainer className={`gi-input `}>
                    {labelText && (
                        <label
                            htmlFor={name}
                            className={`gi-input__label required-${isRequired}`}
                            data-testid={`${id}-text-label`}
                        >
                            <FormattedMessage id={labelText} />
                        </label>
                    )}
                    {withMask ? (
                        <DatePicker
                            {...rest}
                            {...commonProps}
                            selected={value}
                            onChange={date => {
                                onDateChange(date!);
                            }}
                            maxDate={maxDate}
                            minDate={minDate}
                            disabled={disabled}
                            customInput={
                                <DatePickerStyled>
                                    <DatePickerInputMask
                                        value={formatDateToMMDDYYYY(value)}
                                        id={id}
                                        disabled={disabled}
                                        placeholder={placeholder}
                                    />
                                    {showIcon && <FontAwesomeIcon icon="calendar-alt" className="date-picker-icon" />}
                                </DatePickerStyled>
                            }
                        />
                    ) : (
                        <DatePicker
                            {...rest}
                            {...commonProps}
                            selected={value}
                            maxDate={maxDate}
                            minDate={minDate}
                            onChange={e => onDateChange(e!)}
                        />
                    )}
                </DatePickerContainer>
            </>
        );
    },
);

export default ReactDatepicker;
